module.controller('planSamplingHomeSamplingCtrl', [ '$scope', '$rootScope', '$state', 'planSamplingService', 'alertService', 'permissionStatesService', 'securityService',
		function($scope, $rootScope, $state, planSamplingService, alertService, stateService, securityService) {

			$scope.samplings = [];
			$scope.loading = false;
			var vmparent = $scope.$parent;

			$scope.pagination = {
				current : 1,
				total : 0
			};

			$scope.searchSucess = function(response){
				$scope.loading = false;
				var responseData = response.getData();
				$scope.samplings = responseData.results;
				$scope.pagination.total = responseData.totalRegisters;
			};
			
			$scope.searchError = function(){
				$scope.loading = false;
			};
			
			$scope.search = function(page) {
				$scope.loading = true;

				page = page == undefined ? 1 : page;
				$scope.pagination.current = page;

				var filter = {};
				filter.offset = (page - 1) * $rootScope.pageSize;
				filter.limit = $rootScope.pageSize;

				if (securityService.hasRole(ROLE_TYPE.CLIENT.code)) {
					planSamplingService.getSamplingHomeListForClientUser($scope.idPlanSampling, filter).then(function(response) {
						$scope.searchSucess(response);
					}, function(response) {
						$scope.searchError();
					});
				}
				else{
					planSamplingService.getSamplingHomeList($scope.idPlanSampling, filter).then(function(response) {
						$scope.searchSucess(response);
					}, function(response) {
						$scope.searchError();
					});
				}
				
				
			};

			$scope.remove = function(idPlan, idSampling) {
				var sampling = $scope.samplings.find(function(s) {
					return s.id === idSampling
				});
				alertService.showSwtWarningQuestion('Eliminar muestreo de "' + sampling.product.name + '"', function() {
					$scope.loading = true;

					planSamplingService.removeSampling(idPlan, idSampling).then(function(response) {
						$scope.loading = false;
						$scope.search(1);
						alertService.showSuccess('Muestreo eliminado satisfactoriamente');
						vmparent.planSamplingHome.numProducts = vmparent.planSamplingHome.numProducts - 1;
					}, function(response) {
						$scope.loading = false;
					});
				});
			}

			$scope.canGoHome = function() {
				return stateService.canSamplingGoToHome($scope.planSamplingHome.state);
			}

			$scope.canEditSampling = function() {
				return stateService.canEditSampling($scope.planSamplingHome.state);
			}

			$scope.canCreateSampling = function() {
				return stateService.canCreateSampling($scope.planSamplingHome.state);
			}

			$scope.canRemoveSampling = function() {
				return stateService.canRemoveSampling($scope.planSamplingHome.state);
			}

			$scope.search(1);

		} ]);
